<h2 mat-dialog-title>User Defined Fields</h2>

<mat-dialog-content fxFlex="auto">
    <forge-circular-progress *ngIf="!isLoaded"></forge-circular-progress>

    <ng-container *ngIf="isLoaded">
        <div *ngIf="isEmpty" fxLayout="column" fxLayoutAlign="center center">
            <div fxLayout="column" fxLayoutAlign="center center">
                <img alt="Illustration of a clipboard, pen, envelope, and sticky notes" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/setup-1-empty-state-spot-hero.svg">
                <div class="forge-typography--heading2">There are no fields defined.</div>
            </div>
        </div>

        <forge-card *ngIf="!isEmpty" fxLayoutAlign="start center" telemetry="Card-UserDefinedFields">
            <div fxLayout="row">
                <ng-container *ngFor="let field of activeUserDefinedFields">
                    <div fxFlex.gt-md="25" fxFlex.md="33" fxFlex="50">
                        <user-defined-field [field]="field" [viewOnly]="viewOnly">
                        </user-defined-field>
                    </div>
                </ng-container>
            </div>
        </forge-card>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end start">
    <command-bar [commands]="commands" telemetry="CmdBar-CommandKey-UserDefinedFields">
    </command-bar>
</mat-dialog-actions>